/**
 * @fileoverview Integration status API service.
 * @module features/settings/api/integrationStatusService
 */

import apiClient from '@/lib/apiClient'
import { OrgIdSchema } from '@/features/orgs/schemas/orgSchemas'
import {
  IntegrationStatus,
  IntegrationStatusArraySchema,
} from '../schemas/integrationStatusSchema'
import type { z } from 'zod'

/**
 * Query key for integration status queries.
 */
export const INTEGRATIONS_STATUS_QUERY_KEY = ['integrations-status'] as const

/**
 * Fetches the unified integration status for all providers.
 *
 * @param orgId Organization UUID
 * @returns Array of integration statuses
 */
export async function getIntegrationsStatus(
  orgId: z.infer<typeof OrgIdSchema>
): Promise<IntegrationStatus[]> {
  const id = OrgIdSchema.parse(orgId)
  const res = await apiClient.get(`/orgs/${id}/integrations/status`)
  return IntegrationStatusArraySchema.parse(res.data)
}
